import { render, staticRenderFns } from "./page-header-title-content.vue?vue&type=template&id=05f98798&scoped=true"
var script = {}
import style0 from "./page-header-title-content.vue?vue&type=style&index=0&id=05f98798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f98798",
  null
  
)

export default component.exports